import {
    ExpirationDateFieldStatus,
    ISection2DocumentDetails
} from '@models/onboarding-review/section2-document-details';
import {
    observable,
    action,
    computed
} from 'mobx';

export interface ISection2DocumentDetailsStore extends Readonly<ISection2DocumentDetails> {
    readonly expiryDateType: ExpirationDateFieldStatus;
    readonly isCheckboxChecked: boolean | undefined;

    setExpiryDate(expiryDate: string): void;
    setIssuingAuthority(issuingAuthority: string): void;
    setDocumentNumber(documentNumber: string): void;
}

const emptyDocumentDetails: ISection2DocumentDetails = {
    documentId: '',
    documentType: '',
    expiryDate: '',
    issuingAuthority: '',
    number: '',
    isExpiryNaCheckboxChecked: false,
    issuingAuthorityCode: null,
    expiryDateNAChecked: false
};

export class Section2DocumentDetailsStore implements ISection2DocumentDetailsStore {
    @observable
    documentId: string;

    @observable
    documentType: string;

    @observable
    expiryDate: string | null;

    @observable
    issuingAuthority: string;

    @observable
    number: string;

    @observable
    isExpiryNaCheckboxChecked: boolean | undefined;

    @observable
    issuingAuthorityCode: string | null | undefined;

    constructor(details: ISection2DocumentDetails = emptyDocumentDetails) {
        this.documentId = details.documentId;
        this.documentType = details.documentType;
        this.expiryDate = details.expiryDate;
        this.issuingAuthority = details.issuingAuthority;
        this.number = details.number;
        this.isExpiryNaCheckboxChecked = details.expiryDateNAChecked;
        this.issuingAuthorityCode = details.issuingAuthorityCode;
    }

    @computed
    get expiryDateType() {
        switch (this.expiryDate) {
            case '':
                return 'HAS_NOT_BEEN_ENTERED';
            case null:
                return 'HAS_NO_EXPIRATION_DATE';
            default:
                return 'HAS_EXPIRATION_DATE';
        }
    }

    @computed
    get isCheckboxChecked() {
        return this.isExpiryNaCheckboxChecked;
    }

    @action.bound
    setDocumentNumber(documentNumber: string): void {
        this.number = documentNumber;
    }

    @action.bound
    setExpiryDate(expiryDate: string | null): void {
        this.expiryDate = expiryDate;
    }

    @action.bound
    setIssuingAuthority(issuingAuthority: string): void {
        this.issuingAuthority = issuingAuthority;
    }

    @action.bound
    setIsExpiryNaCheckboxChecked(isExpiryNaCheckboxChecked: boolean): void {
        this.isExpiryNaCheckboxChecked = isExpiryNaCheckboxChecked
    }

    @action.bound
    setIssuingAuthorityCode(code: string): void {
        this.issuingAuthorityCode = code;
    }
}



// WEBPACK FOOTER //
// ./src/stores/onboarding-review/section2-document-details-store.ts